import React from "react"
import { i18n } from "@lingui/core"
import { t } from "@lingui/macro"
import { SuiteCardImageFooterWithTooltip } from "@silversea-ssc/ui-components-react"
import getGuaranteedSuiteInfoContent from "../../../../../components/GuaranteedSuiteInfo/content"

export const GuaranteedCardImageFooter = () => {
    const guaranteedSuiteInfoContent = getGuaranteedSuiteInfoContent()
    return (
        <SuiteCardImageFooterWithTooltip
            buttonLabel={i18n._(t`What's this?`)}
            label={i18n._(guaranteedSuiteInfoContent.label)}
            details={<React.Fragment>{i18n._(guaranteedSuiteInfoContent.tooltipDetails)}</React.Fragment>}
        />
    )
}

export const PartialCardImageFooter = () => (
    <SuiteCardImageFooterWithTooltip
        buttonLabel={i18n._(t`What can I do?`)}
        label={i18n._(t`Currently not bookable`)}
        details={
            <React.Fragment>
                {i18n._(
                    t`Ask for a personalized summary and a Silversea Travel Agent will contact you soon to answer any questions and finalise your booking`,
                )}
            </React.Fragment>
        }
    />
)
